/** Supported UI locales for VO2 Peaks PWA. */
export const SUPPORTED_LOCALES = ['en', 'fa', 'ar', 'tr'] as const;

export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: AppLocale = 'fa';

/** Locales that use right-to-left layout. */
export const RTL_LOCALES: readonly AppLocale[] = ['fa', 'ar'];

export function isRtlLocale(locale: string): boolean {
  return RTL_LOCALES.includes(locale as AppLocale);
}

export function normalizeLocale(raw: string | null | undefined): AppLocale {
  const code = (raw ?? '').split('-')[0].toLowerCase();
  if (SUPPORTED_LOCALES.includes(code as AppLocale)) {
    return code as AppLocale;
  }
  return DEFAULT_LOCALE;
}

export const LOCALE_LABELS: Record<AppLocale, string> = {
  en: 'English',
  fa: 'فارسی',
  ar: 'العربية',
  tr: 'Türkçe',
};
